import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { blacklistHistory } from '../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setHistory, clearHistory } from "../store/reducers/history"
import { normalizePath } from 'utils/helper';

const useNavigation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const historyRedux = useSelector((state) => state.history)

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      dispatch(setHistory(location.pathname));
    });

    const handlePopState = (event) => {
      const targetPath = window.location.pathname;
      const isBlacklisted = blacklistHistory.some((blackPath) => targetPath?.startsWith(blackPath));
      if (isBlacklisted) return;
      history.replace(targetPath, event.state?.state || {});
    };

		window.addEventListener('popstate', handlePopState);

		return () => {
			unlisten();
			window.removeEventListener('popstate', handlePopState);
		};
  }, [history, dispatch]);  

  const push = (path, state = {}, clear = false) => {
    if (clear) {
      dispatch(clearHistory());
    }
    history.push(normalizePath(path), state);
  };

  const replace = (path, state = {}) => {
    const isBlacklisted = blacklistHistory.some((blackPath) => path.startsWith(blackPath));
    if (isBlacklisted) return;
    history.replace(normalizePath(path), state);
  };

  const back = () => {
    const previousPath = historyRedux[historyRedux.length - 2];
    const isBlacklisted = blacklistHistory.some((blackPath) => previousPath?.startsWith(blackPath));
    if (isBlacklisted) return;
    history.goBack();
  };

  return {
    push,
    replace,
    back,
  };
};

export default useNavigation;
